import InnerComponent from '@Components/Purchase/Rfq/RfqList';
import orgContainer from '@Components/AppContainer';

const RfqList = () => ((orgContainer(InnerComponent)));
export default RfqList;
